import { Dispatch } from "redux";
import ordersSlice from "./slice";
import {
  getAcceptedOrders,
  getAssingedOrders,
} from "@/services/merchant.services";
import { mergeUnique } from "../helper/transformer";
import { parseOrder } from "../parser/order";
import { Order, OrderStatus } from "@/models";
import { List } from "immutable";

const showArchivedOrders = (order: Order) => {
  const orderDate = new Date(Number(order.placedTimestamp) * 1000);
  const currentDate = new Date();
  const hoursDifference =
    (currentDate.getTime() - orderDate.getTime()) / (1000 * 60 * 60);
  const archivedIds = JSON.parse(
    localStorage.getItem("archivedIds") || "[]",
  ).map(Number);
  const isArchived = archivedIds.includes(Number(order.id));

  return (
    (hoursDifference > 24 &&
      order.status >= OrderStatus.ACCEPTED &&
      order.status !== OrderStatus.COMPLETED &&
      order.disputeInfo?.redactTransId?.toString() == "0") ||
    isArchived
  );
};

const filterArchivedOrders = (order: Order) => {
  const orderDate = new Date(Number(order.placedTimestamp) * 1000);
  const currentDate = new Date();
  const hoursDifference =
    (currentDate.getTime() - orderDate.getTime()) / (1000 * 60 * 60);
  const archivedIds = JSON.parse(
    localStorage.getItem("archivedIds") || "[]",
  ).map(Number);
  const isArchived = archivedIds.includes(Number(order.id));

  return (
    hoursDifference < 24 &&
    order.status >= OrderStatus.ACCEPTED &&
    order.status !== OrderStatus.COMPLETED &&
    order.status !== OrderStatus.CANCELLED &&
    !isArchived
  );
};

export const fetchOrdersThunk =
  (account: { address: string }): any =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(ordersSlice.actions.loading());
      const assignedOrders = await getAssingedOrders(account);
      const acceptedOrders = await getAcceptedOrders(account);
      const allOrders = mergeUnique(
        await Promise.all(assignedOrders.map(parseOrder)),
        await Promise.all(acceptedOrders.map(parseOrder)),
        "id",
      );
      const latestOrders = List(
        (await Promise.all(assignedOrders.map(parseOrder))).filter(
          (order) => order.status === OrderStatus.PLACED,
        ),
      );

      const activeOrders = List(
        await Promise.all(
          acceptedOrders.filter(filterArchivedOrders).map(parseOrder),
        ),
      );

      const archivedOrders = List(
        await Promise.all(
          acceptedOrders.filter(showArchivedOrders).map(parseOrder),
        ),
      );

      const pastOrders = List(
        (await Promise.all(acceptedOrders.map(parseOrder))).filter(
          (order) =>
            order.status === OrderStatus.COMPLETED ||
            order.status === OrderStatus.CANCELLED,
        ),
      );

      dispatch(
        ordersSlice.actions.setAllOrders({
          allOrders,
          latestOrders,
          activeOrders,
          archivedOrders,
          pastOrders,
        }),
      );
      dispatch(ordersSlice.actions.success());
    } catch (err) {
      dispatch(ordersSlice.actions.failed());
    }
  };

export const setAssignedOrderThunk =
  (assignedOrder: Order): any =>
  async (dispatch: Dispatch) => {
    try {
      const _order = await parseOrder(assignedOrder);
      dispatch(ordersSlice.actions.setAssignedOrder(_order));
    } catch (err) {
      console.error(err);
    }
  };

export const resetAssignedOrderThunk =
  (): any => async (dispatch: Dispatch) => {
    try {
      dispatch(ordersSlice.actions.setAssignedOrder(null));
    } catch (err) {
      console.error(err);
    }
  };
